export default __webpack_public_path__ + "static/media/logo-dark.49633106.svg";